<template>
    <div class="product-select-footer">
        <div class="container" v-if="checkoutAvailableFrom">
            <div class="col d-flex align-items-center justify-content-center checkout-available-from">
                <p>
                    {{ $t('UpsellingFooter.checkoutAvailableFrom', { date: checkoutAvailableFrom }) }}
                </p>
            </div>
        </div>
        <div v-else class="container">
            <slot>
                <div class="row">
                    <div class="product-select-footer__left col d-none d-lg-block">
                        <slot name="left"></slot>
                    </div>

                    <div class="product-select-footer__right col d-flex align-items-center justify-content-center">
                        <slot name="right">
                            <div v-if="selectedVariant" class="row product-select-footer__right-row no-gutters">
                                <div v-if="price" class="col">
                                    <div class="row align-items-baseline">
                                        <div class="product-select-footer__prefix col-12 col-md-auto">
                                            {{ $t('UpsellingFooter.totalPrice') }}
                                        </div>
                                        <div class="product-select-footer__price col-12 col-md-auto">
                                            {{ price }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col">
                                    <nuxt-link
                                        :to="link"
                                        @click.native="$emit('submit', selectedVariant)"
                                        class="btn btn-primary product-select-footer__button-proceed btn-lg py-3 text-decoration-none text-uppercase btn-add-to-cart"
                                    >
                                        {{ $t('UpsellingFooter.proceedToCheckout') }}
                                    </nuxt-link>
                                </div>
                            </div>
                        </slot>
                    </div>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
import formatPrice from '@/filters/formatPrice';
import productStickyFooter from '@/mixins/injectStickyFooter';

/**
 * @typedef {import('./VariantsList.vue').Variant} Variant
 */

export default {
    name: 'ProductSelectBottomFooter',
    mixins: [productStickyFooter({ stickyFooterSelector: '.product-select-footer' })],

    props: {
        /**
         * @type { Variant }
         */
        selectedVariant: {
            type: Object
            //required: true - disabled as we now support direct booking without variant selected initially
        },
        arrivalDate: {
            type: String
        },
        checkoutAvailableFrom: {
            type: String
        }
    },

    computed: {
        price() {
            if (this.selectedVariant.price.surcharge != null) {
                return formatPrice(this.selectedVariant.price.surcharge);
            }
            if (this.selectedVariant.price.regularPriceValues != null) {
                return formatPrice(this.selectedVariant.price.regularPriceValues.price);
            }
        },
        link() {
            return {
                name: 'checkout',
                query: Object.assign({
                    ['productVariantId']: this.selectedVariant.id,
                    quantity: 1,
                    ...(this.arrivalDate && { arrivalDate: this.arrivalDate })
                })
            };
        }
    },

    mounted() {
        if (
            this.$nuxt.iframeLayout &&
            typeof this.$nuxt.iframeLayout.isInsideIframe === 'function' &&
            this.$nuxt.iframeLayout.isInsideIframe()
        ) {
            this.$nuxt.iframeLayout.fixPositionInIframe(this.$el);
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/_mixins.scss';
@use '@/styles/variables';
@use 'sass:map';

.product-select-footer {
    $price-height: 32px;

    position: fixed;
    padding-top: 10px;
    padding-bottom: 10px;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: map.get(variables.$z-indices, 'footer-mobile');
    box-shadow: 0px -12px 24px rgba(0, 0, 0, 0.07);
    border-top-width: 1px;
    border-top-style: solid;
    line-height: 24px;
    color: var(--body-color);
    border-color: var(--border-color);
    background-color: var(--aside-darker-bg);

    &__left {
    }

    &__prefix,
    &__price {
        line-height: normal;
    }

    &__price {
        font-size: $price-height;
        font-weight: bold;
    }

    &__right-row {
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        text-align: center;
    }

    &__button-proceed {
        width: 100%;
        max-width: 300px;
        white-space: nowrap;
    }

    @include mixins.mobile-only {
        position: sticky;
    }

    .checkout-available-from {
        font-weight: bold;
        color: #930202;
    }

}
</style>
